import { NodeProps } from '@xyflow/react';
import BaseNode from './baseNode';
import { DataSourceNodeType } from './nodesUtils';

const DataSourceNode = (node: NodeProps<DataSourceNodeType>) => {
  return (
    <BaseNode
      node={node}
      label={node.data.entity.dataSourceDef?.name || 'Data source'}
      icon={node.data.entity.dataSourceDef?.instanceIcon || 'database'}
      canDelete={true}
    />
  );
};

export default DataSourceNode;
